import axios from "axios";
import {eventBus} from "@/eventBus";

const baseURL = process.env.NODE_ENV === 'production'
  ? 'http://affystat.durban:5000'
  : 'http://127.0.0.1:5000'

const Axios = axios.create({
  baseURL
});

Axios.interceptors.request.use(function (config) {
  // Do something before request is sent

  if (config.url === 'login') {
    return config;
  }

  const token = localStorage.getItem('token')
  const userId = localStorage.getItem('userId')
  if (!token || !userId) {
    throw new Error('Нет ключа авторизации')
  }

  config.headers['authorization'] = token;
  config.headers['id'] = userId;

  return config;
}, function (error) {
  const errorMsg = error.message || ''
  eventBus.$emit('apiError', errorMsg)
  return Promise.reject(error);
});

Axios.interceptors.response.use(function (response) {
    return response;
  },
  function (error) {
    const errorMsg = error.response?.data?.message || ''
    eventBus.$emit('apiError', errorMsg)
    if (errorMsg === 'Невалидный ключ') {
      eventBus.$emit('logout')
    }
    return Promise.reject(error);
  });

export const ApiService = {
  login(data) {
    return Axios.post('login', data)
      .then(res => res.data)
  },

  getEmployerData({botName}) {
    return Axios.get(`getEmployers?botName=${botName}`)
      .then(res => res.data)

  },

  getUtms({botName}) {
    return Axios.get(`getUtms?botName=${botName}`)
      .then(res => res.data);
  },

  getCourses({botName}) {
    return Axios.get(`getCourses?botName=${botName}`)
      .then(res => res.data);
  },

  getFullCoursesData({botName}) {
    return Axios.get(`getFullCoursesData?botName=${botName}`)
      .then(res => res.data);
  },

  saveCourse({botName, courseName, courseLink}) {
    return Axios.post(`saveCourse?botName=${botName}`, {courseName, courseLink})
      .then(res => res.data);
  },

  deleteCourseById({botName, courseId}) {
    return Axios.delete(`deleteCourse?botName=${botName}&courseId=${courseId}`)
      .then(res => res.data);
  },

  getUserAmountForBot(botName) {
    return Axios.get(`getUserAmountForBot?botName=${botName}`)
      .then(res => res.data);
  }

}
